import type { ReactNode } from 'react';
import RacketTwo from 'svg/RacketTwo';
import Star from 'svg/Star';
import Users from 'svg/Users';
import type { PlayerProfileView } from 'screens/PlayerProfile/types';

interface Props {
  stats: PlayerProfileView['stats'];
}

function StatCard({ value, label, icon }: { value: string; label: string; icon: ReactNode }) {
  return (
    <div className="flex flex-1 flex-col gap-ds-md rounded-xl border border-color-border-card-lightmode bg-color-bg-lightmode-primary p-ds-lg shadow-[0px_4px_16px_0px_rgba(0,0,0,0.04)] dark:border-color-border-card-darkmode dark:bg-color-bg-darkmode-primary md:flex-row md:items-start md:justify-between md:rounded-3xl md:p-ds-xl">
      <span className="text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
        {icon}
      </span>
      <div className="flex flex-col gap-ds-xs md:gap-ds-md">
        <p className="typography-product-heading-mobile md:typography-product-heading-compact-desktop text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          {value}
        </p>
        <p className="typography-product-text-card-mobile md:typography-product-chips-filters text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary md:text-color-text-lightmode-primary md:dark:text-color-text-darkmode-primary">
          {label}
        </p>
      </div>
    </div>
  );
}

export default function ProfileStats({ stats }: Props) {
  return (
    <div className="flex items-stretch gap-ds-md md:gap-ds-lg">
      <StatCard
        value={stats.averageRating != null ? stats.averageRating.toFixed(1) : '0'}
        label={stats.reviewCount === 1 ? '1 review' : `${stats.reviewCount} reviews`}
        icon={<Star className="size-5 shrink-0 md:size-6" />}
      />
      <StatCard
        value={String(stats.gamesPlayed)}
        label="Games played"
        icon={<RacketTwo className="size-5 shrink-0 md:size-6" />}
      />
      <StatCard
        value={String(stats.followers)}
        label="Followers"
        icon={<Users className="size-5 shrink-0 md:size-6" />}
      />
    </div>
  );
}
